import styled from '@emotion/styled'
import { styles, theme } from 'app/theme'
import { rgba } from 'emotion-rgba'
import React, { memo } from 'react'

export interface Props {
  active?: boolean
  category?: string
  onClick?: (e: any) => void
  title?: string
}

export const Filter = memo(function Filter({
  active = false,
  category,
  onClick,
  title,
}: Props) {
  if (!title || !category) {
    return null
  }

  return (
    <Container
      className={active ? 'active' : undefined}
      data-category={category}
      onClick={onClick}
    >
      {title}
    </Container>
  )
})

const Container = styled.div`
  ${styles.label}

  color: ${rgba(theme.colors.variants.neutralDark1, 0.5)};

  cursor: pointer;
  margin-right: 3rem;
  position: relative;
  text-transform: uppercase;
  transition: 0.3s cubic-bezier(0.25, 1, 0.5, 1);

  &:last-of-type {
    margin-right: 0;
  }

  &:hover {
    color: ${({ theme }) => theme.colors.variants.neutralDark1};
  }

  &.active {
    color: ${({ theme }) => theme.colors.variants.neutralDark1};
    pointer-events: none;
  }
`
